import { createApp, capitalize } from 'vue';
import { createPinia } from 'pinia';
import ui from '@nuxt/ui/vue-plugin';
import App from './App.vue';
import router from './router';
import './index.css';
import { Tabs, Tab } from 'vue3-tabs-component';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import 'vue3-toastify/dist/index.css';
import { useEnvironment } from './composables/useEnvironment';

const pinia = createPinia();
const app = createApp(App)
  .component('tabs', Tabs)
  .component('tab', Tab)
  .component('v-select', vSelect);

const { isProd, isDemo } = useEnvironment();

app.config.globalProperties.window = window;

app.use(router).use(pinia).use(ui).mount('#app');

if (!isProd() || !isDemo()) {
  window.__pinia = pinia;
}

document.title = `Auxo${
  import.meta.env.VITE_CLIENT_PREFIX
    ? ` - ${capitalize(import.meta.env.VITE_CLIENT_PREFIX)}`
    : ''
}`;
